export const customGlCodesEn = {
  GL_CODE_MANAGEMENT: 'GL Code Management',
  CUSTOM_GL_CODE: 'Custom GL Code',
  CUSTOM_GL_CODES: 'Custom GL Codes',
  CREATE_CUSTOM_GL_CODE: 'Create Custom GL Code',
  UPDATE_CUSTOM_GL_CODE: 'Update Custom GL Code',
  GL_CODE: 'GL Code',
  DESCRIPTION: 'Description',
  CUSTOM_GL_CODE_FORMAT_ERROR: 'The GL code may only contain numbers and, optionally, a single decimal point (e.g. 6004 or 6004.2).',
  CUSTOM_GL_CODE_MAX_LENGTH_ERROR: 'The GL code must be at most 7 characters.',
  DELETE_CUSTOM_GL_CODE: 'Delete Custom GL Code',
  DELETE_CUSTOM_GL_CODE_CONFIRMATION: 'Are you sure you want to delete this custom GL code?',
  CUSTOM_GL_CODE_IN_USE_WARNING: 'Heads up — this code is in use:',
  CUSTOM_GL_CODE_USAGE_INBOUND_ACCOUNT: 'connected to an inbound account',
  CUSTOM_GL_CODE_USAGE_OUTBOUND_ACCOUNT: 'connected to an outbound account',
  CUSTOM_GL_CODE_USAGE_RETURNED_ACCOUNT: 'connected to a returned payments account',
  CUSTOM_GL_CODE_CREATED_SUCCESSFULLY: 'Custom GL code created successfully',
  CUSTOM_GL_CODE_UPDATED_SUCCESSFULLY: 'Custom GL code updated successfully',
  CUSTOM_GL_CODE_DELETED_SUCCESSFULLY: 'Custom GL code deleted successfully',
  PARENT_CLASSIC_GL_CODE: 'Parent Classic GL Code',
  PARENT_CLASSIC_GL_CODE_NONE: '-',
  PARENT_CLASSIC_GL_CODE_UNCATEGORIZED: 'Uncategorized',
  OTHER_CUSTOM_GL_CODES: 'Other Custom GL Codes',
  CUSTOM_GL_CODES_DESCRIPTION: 'Allow this factor to define its own GL codes, nested under a classic GL code purpose.',
  CUSTOM_GL_CODE_INTENDED_USE: 'Intended Use',
  CUSTOM_GL_CODE_INTENDED_USE_NONE: '-',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE: 'Additional Fee',
  CUSTOM_GL_CODE_INTENDED_USE_PAYMENT_TRANSACTION: 'Received Payments',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_AS_PURCHASE_FEE: 'Use as Additional Fee (will appear as Purchasing Fee in reports)',
  CUSTOM_GL_CODE_INTENDED_USE_OUTBOUND_PAYMENT_TRANSACTION: 'Funding',
  CUSTOM_GL_CODE_INTENDED_USE_RETURNED_PAYMENT: 'Returned Payments',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_INFO:
    'Only codes parented to "Additional Fee" can be used as the custom GL code for additional fees.',
  CUSTOM_GL_CODE_INTENDED_USE_PAYMENT_TRANSACTION_INFO:
    'Only codes parented to "Assign Payment To Invoice" are considered for assignment under Received Payments.',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_AS_PURCHASE_FEE_INFO:
    'This code will be used as an additional fee, but will appear as "Purchasing Fee" in all reports and GL exports, since it is parented to that classic GL code.',
  CUSTOM_GL_CODE_INTENDED_USE_OUTBOUND_PAYMENT_TRANSACTION_INFO:
    'Only codes parented to "Fund Invoice Groups" are considered for assignment under Funding.',
  CUSTOM_GL_CODE_INTENDED_USE_RETURNED_PAYMENT_INFO:
    'Only codes parented to "Returned Payment" are considered for assignment under Returned Payments.',
  CUSTOM_GL_CODE_CANNOT_BE_EDITED: 'The GL code cannot be changed after it is created.',
}

export const customGlCodesEs: typeof customGlCodesEn = {
  GL_CODE_MANAGEMENT: 'Gestión de Códigos GL',
  CUSTOM_GL_CODE: 'Código GL Personalizado',
  CUSTOM_GL_CODES: 'Códigos GL Personalizados',
  CREATE_CUSTOM_GL_CODE: 'Crear Código GL Personalizado',
  UPDATE_CUSTOM_GL_CODE: 'Actualizar Código GL Personalizado',
  GL_CODE: 'Código GL',
  DESCRIPTION: 'Descripción',
  CUSTOM_GL_CODE_FORMAT_ERROR: 'El código GL solo puede contener números y, opcionalmente, un punto decimal (ej. 6004 o 6004.2).',
  CUSTOM_GL_CODE_MAX_LENGTH_ERROR: 'El código GL debe tener como máximo 7 caracteres.',
  DELETE_CUSTOM_GL_CODE: 'Eliminar Código GL Personalizado',
  DELETE_CUSTOM_GL_CODE_CONFIRMATION: '¿Estás seguro de que deseas eliminar este código GL personalizado?',
  CUSTOM_GL_CODE_IN_USE_WARNING: 'Atención — este código está en uso:',
  CUSTOM_GL_CODE_USAGE_INBOUND_ACCOUNT: 'está conectado a una cuenta inbound',
  CUSTOM_GL_CODE_USAGE_OUTBOUND_ACCOUNT: 'está conectado a una cuenta outbound',
  CUSTOM_GL_CODE_USAGE_RETURNED_ACCOUNT: 'está conectado a una cuenta de pagos devueltos',
  CUSTOM_GL_CODE_CREATED_SUCCESSFULLY: 'Código GL personalizado creado con éxito',
  CUSTOM_GL_CODE_UPDATED_SUCCESSFULLY: 'Código GL personalizado actualizado con éxito',
  CUSTOM_GL_CODE_DELETED_SUCCESSFULLY: 'Código GL personalizado eliminado con éxito',
  PARENT_CLASSIC_GL_CODE: 'Código GL Clásico Padre',
  PARENT_CLASSIC_GL_CODE_NONE: '-',
  PARENT_CLASSIC_GL_CODE_UNCATEGORIZED: 'Sin categorizar',
  OTHER_CUSTOM_GL_CODES: 'Otros Códigos GL Personalizados',
  CUSTOM_GL_CODES_DESCRIPTION: 'Permite que este factor defina sus propios códigos GL, anidados bajo un propósito de código GL clásico.',
  CUSTOM_GL_CODE_INTENDED_USE: 'Uso Previsto',
  CUSTOM_GL_CODE_INTENDED_USE_NONE: '-',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE: 'Additional Fee',
  CUSTOM_GL_CODE_INTENDED_USE_PAYMENT_TRANSACTION: 'Pagos Recibidos',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_AS_PURCHASE_FEE: 'Usar como Additional Fee (aparecerá como Purchasing Fee en los reportes)',
  CUSTOM_GL_CODE_INTENDED_USE_OUTBOUND_PAYMENT_TRANSACTION: 'Financiamiento',
  CUSTOM_GL_CODE_INTENDED_USE_RETURNED_PAYMENT: 'Pagos Devueltos',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_INFO:
    'Sólo los códigos cuyo padre sea "Additional Fee" se pueden usar como código GL personalizado para additional fees.',
  CUSTOM_GL_CODE_INTENDED_USE_PAYMENT_TRANSACTION_INFO:
    'Sólo los códigos cuyo padre sea "Assign Payment To Invoice" son considerados para ser asignados bajo Pagos Recibidos.',
  CUSTOM_GL_CODE_INTENDED_USE_ADDITIONAL_FEE_AS_PURCHASE_FEE_INFO:
    'Este código se usará como additional fee, pero aparecerá como "Purchasing Fee" en todos los reportes y exportaciones de GL, ya que su padre es ese código GL clásico.',
  CUSTOM_GL_CODE_INTENDED_USE_OUTBOUND_PAYMENT_TRANSACTION_INFO:
    'Sólo los códigos cuyo padre sea "Fund Invoice Groups" son considerados para ser asignados bajo Financiamiento.',
  CUSTOM_GL_CODE_INTENDED_USE_RETURNED_PAYMENT_INFO:
    'Sólo los códigos cuyo padre sea "Returned Payment" son considerados para ser asignados bajo Pagos Devueltos.',
  CUSTOM_GL_CODE_CANNOT_BE_EDITED: 'El código GL no se puede modificar una vez creado.',
}
